import Vue from "vue";
import VueRouter from "vue-router";
// import AccountView from '../views/AccountView.vue'
import EnergyView from "../views/EnergyView.vue";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import NotFound from "../components/not-found.vue";
import UsageView from "../views/UsageView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/account/",
    name: "account",
    component: () =>
      import(/* webpackChunkName: "account" */ "../views/AccountView.vue"),
    children: [
      {
        path: "trailers",
        name: "trailers-map",
        component: () =>
          import(
            /* webpackChunkName: "account" */ "../components/trailers-form.vue"
          ),
      },
      {
        name: "account",
        path: ":id?",
        component: () =>
          import(
            /* webpackChunkName: "account" */ "../components/account-form.vue"
          ),
      },
    ],
  },
  // {
  //   path: '/account/:id?',
  //   name: 'account',
  //   component: AccountView,
  // },
  {
    path: "/api-explorer",
    name: "apiExplorer",
    component: () =>
      import(
        /* webpackChunkName: "apiExplorer" */ "../views/ApiExplorerView.vue"
      ),
  },
  {
    path: "/testing",
    name: "testingView",
    component: () =>
      import(/* webpackChunkName: "apiExplorer" */ "../views/TestingView.vue"),
  },
  {
    path: "/energy/:id?",
    name: "energy",
    component: EnergyView,
  },
  {
    path: "/usage/:id?",
    name: "usage",
    component: UsageView,
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
  },
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/:slug?",
    name: "404",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
